<template>
  <div class="mb-3 timeline-block">
    <span class="timeline-step p-3" :class="`bg-${computedColor}`">
      <i class="material-icons" :class="computedIcon.class">{{ computedIcon.component }}</i>
    </span>
    <div class="timeline-content">
      <h6 class="mb-0 text-sm font-weight-bold" :class="$parent.darkMode ? 'text-white' : 'text-dark'">
        {{ title }}
        <i v-if="isAutoScheduled" class="material-icons text-info" style="font-size: 14px; vertical-align: middle; margin-left: 4px;" title="Auto-scheduled">smart_toy</i>
      </h6>
      <p class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
        {{ dateTime }}
      </p>
      <div class="" v-if="type == 'admin'">
        <p v-if="total_workgroups !== undefined && total_workgroups !== null && total_workgroups !== ''"
          class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Total Workgroups: {{ total_workgroups }}
        </p>
        <p v-if="total_persons_needed !== undefined && total_persons_needed !== null && total_persons_needed !== ''"
          class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Total Persons Needed: {{ total_persons_needed }}
        </p>
        <p v-if="shouldShowPersonCounts" class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Total Persons Scheduled: {{ total_persons_scheduled || 0 }}
        </p>
        <p v-if="shouldShowPersonCounts" class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Total Persons Confirmed: {{ total_persons_confirmed || 0 }}
        </p>
        <p v-if="shouldShowPersonCounts" class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Total Persons Declined: {{ total_persons_declined || 0 }}
        </p>
        <p v-if="description" class="mt-3 mb-2 text-sm" :class="$parent.darkMode ? 'text-white' : 'text-dark'">
          {{ description }}
        </p>
      </div>
       <p v-if="workgroupname" class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
          Workgroup Name: {{ workgroupname }}
        </p>
      <p v-if="status" class="mt-1 mb-0 text-xs text-secondary font-weight-normal">
        Status: {{ status }} {{ status !== "pending" ? `[via ${method}]` : "" }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "TimelineItem",
  props: {
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: Object,
      component: String,
      class: String,
      default: () => { },
    },
    title: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    total_persons_needed: {
      type: [String, Number],
      default: "",
    },
    total_workgroups: {
      type: [String, Number],
      default: null,
    },
    total_persons_declined: {
      type: [String, Number],
      default: "",
    },
    total_persons_confirmed: {
      type: [String, Number],
      default: "",
    },
    total_persons_scheduled: {
      type: [String, Number],
      default: "",
    },
    workgroupname: {
      type: String
    },
    showPersonCounts: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ""
    },
     method: {
      type: String,
      default: ""
    },
    statusid: {
      type: [Number, String],
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    isAutoScheduled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Show person counts if explicitly enabled or if any of the values exist
    shouldShowPersonCounts() {
      return this.showPersonCounts ||
        this.total_persons_scheduled !== undefined ||
        this.total_persons_confirmed !== undefined ||
        this.total_persons_declined !== undefined;
    },
    // Computed icon based on statusid, fallback to prop icon
    computedIcon() {
      if (this.type == 'admin') {
        return { component: 'notifications', class: 'text-white' };
      }
      else if (this.statusid !== null && this.statusid !== undefined) {
        const statusIdNum = Number(this.statusid);
        if (statusIdNum === 1) {
          // Completed - check circle icon
          return {
            component: 'check_circle',
            class: 'text-white'
          };
        } else if (statusIdNum === 2) {
          // Declined - close/cross icon
          return {
            component: 'close',
            class: 'text-white'
          };
        } else if (statusIdNum === 3) {
          // Pending/Question - question mark icon
          return {
            component: 'question_mark',
            class: 'text-white'
          };
        }
      }
      // Fallback to prop icon if provided, otherwise default
      return this.icon && this.icon.component ? this.icon : { component: 'notifications', class: '' };
    },
    // Computed color based on statusid, fallback to prop color
    computedColor() {
      if (this.type == 'admin') {
        return 'success';
      }
      else if (this.statusid !== null && this.statusid !== undefined) {
        const statusIdNum = Number(this.statusid);
        if (statusIdNum === 1) {
          // Completed - green/success
          return 'success';
        } else if (statusIdNum === 2) {
          // Declined - red/danger
          return 'danger';
        } else if (statusIdNum === 3) {
          // Pending/Question - blue/info
          return 'info';
        }
      }
      // Fallback to prop color if provided
      return this.color || 'gradient-dark';
    }
  },
};
</script>
